// RFC 7636 PKCE helpers for the auth.sentrivox.com redirect+PKCE login (v4 §7).
// Browser-native (Web Crypto API) - no new dependency for this.

const VERIFIER_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';

function base64UrlEncode(bytes) {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/** A code_verifier per RFC 7636 §4.1: 43-128 chars from [A-Za-z0-9-._~]. Uses 96 random bytes
 * mapped into the allowed alphabet (not base64url of raw bytes) so the result is unambiguously
 * within spec regardless of alphabet-mapping edge cases. */
export function generateCodeVerifier() {
  const randomBytes = crypto.getRandomValues(new Uint8Array(96));
  let verifier = '';
  for (let i = 0; i < randomBytes.length; i++) {
    verifier += VERIFIER_ALPHABET[randomBytes[i] % VERIFIER_ALPHABET.length];
  }
  return verifier;
}

/** S256 code_challenge: base64url(SHA-256(verifier)) — must match auth-service's
 * lib/pkce.js verifyChallenge exactly (same algorithm, same encoding). */
export async function generateCodeChallenge(verifier) {
  const data = new TextEncoder().encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode(new Uint8Array(digest));
}

export function generateState() {
  return base64UrlEncode(crypto.getRandomValues(new Uint8Array(24)));
}
